import React from 'react';
import EmElaboracao from './EmElaboracao';

export default function GestaoPreviaRecargas() {
  return (
    <EmElaboracao
      title="Gestão de Prévia de Recargas"
      description="Solicitações e controle de prévia de recargas de medicamentos e insumos."
      icon="🔋"
      section="Homecare"
    />
  );
}
